import { actionTypes } from '../actions/types';

type AppActions = import('../actions/types').AppActions;

export interface SigningReducer {
    signingUrl?: string;
    errorMessage: any;
}

export const initialState: SigningReducer = {
    signingUrl: undefined,
    errorMessage: undefined,
};

export const signingReducer = (state = initialState, action: AppActions = {} as AppActions): SigningReducer => {
    switch (action.type) {
        case actionTypes.SEND_ORDER_FULFILLED: {
            const { esigningUrl } = action.payload;
            return {
                ...state,
                signingUrl: String(esigningUrl),
            };
        }

        case actionTypes.FETCH_STATUS_FULFILLED: {
            const { esigningUrl } = action.payload.response;
            return {
                ...state,
                signingUrl: String(esigningUrl),
            };
        }

        case actionTypes.FETCH_CASE_FULFILLED: {
            const { esigningUrl } = action.payload;
            return {
                ...state,
                signingUrl: String(esigningUrl),
            };
        }

        default:
            return state;
    }
};
